import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isContactDrawerOpen: false,
  activeContactDrawer: '',
  currentContactProfile: null,
  contactDrawerSource: null,
}

const slice = createSlice(({
  name: 'contacts',
  initialState,
  reducers: {
    toggleContactDrawerOpen: (state) => ({
      ...state,
      isContactDrawerOpen: !state.isContactDrawerOpen
    }),
    setSelectedContactDrawer: (state, payload) => ({
      ...state,
      activeContactDrawer: payload.payload
    }),
    setCurrentContact: (state, payload) => ({
      ...state,
      currentContact: payload.payload
    }),
    setCurrentContactProfile: (state, { payload: currentContact }) => ({
      ...state,
      currentContactProfile: currentContact,
      activeContactDrawer: 'profile',
      isContactDrawerOpen: true
    })
  }
}
))

export const {
  reducer,
  actions: {
    toggleContactDrawerOpen,
    setCurrentContact,
    setCurrentContactProfile,
    setSelectedContactDrawer
  }
} = slice
